var _mask, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardNfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 57,
    viewBox: "0 0 38 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_544_135",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1997 53.245C37.1997 55.0373 35.7467 56.4902 33.9544 56.4902L3.44505 56.4902C1.65273 56.4902 0.199768 55.0373 0.199768 53.2449L0.199773 3.24594C0.199773 1.45362 1.65273 0.000664464 3.44506 0.000664621L33.9544 0.000667288C35.7468 0.000667445 37.1997 1.45363 37.1997 3.24595L37.1997 53.245Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1997 53.245C37.1997 55.0373 35.7467 56.4902 33.9544 56.4902L3.44505 56.4902C1.65273 56.4902 0.199768 55.0373 0.199768 53.2449L0.199773 3.24594C0.199773 1.45362 1.65273 0.000664464 3.44506 0.000664621L33.9544 0.000667288C35.7468 0.000667445 37.1997 1.45363 37.1997 3.24595L37.1997 53.245Z",
    fill: "#C28333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1997 56.4902L0.199768 56.4902L37.1997 56.4902M-0.800227 3.24595C-0.800227 0.901341 1.10045 -0.999336 3.44506 -0.999335L32.9544 -0.999333C35.299 -0.999333 37.1997 0.901344 37.1997 3.24595C37.1997 2.00592 35.7467 1.00067 33.9544 1.00067L3.44506 1.00066C2.20502 1.00066 1.19977 2.00591 1.19977 3.24595L-0.800227 3.24595ZM1.19977 3.24595M37.1997 0.000667572L37.1997 56.4902L37.1997 0.000667572M3.44505 56.4902C1.10044 56.4902 -0.800232 54.5896 -0.800232 52.2449L-0.800227 3.24595C-0.800227 0.901341 1.10045 -0.999336 3.44506 -0.999335L3.44506 1.00066C2.20502 1.00066 1.19977 2.00591 1.19977 3.24595L1.19977 53.2449C1.19977 55.0373 2.20502 56.4902 3.44505 56.4902Z",
    fill: "#C28333",
    mask: "url(#path-1-inside-1_544_135)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6331 28.2455L30.2108 28.2455M30.2108 28.2455L37.1997 36.2393M30.2108 28.2455L37.1997 20.7846",
    stroke: "#773D0D",
    strokeWidth: 1.62264
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1775 28.2455L7.59972 28.2455M7.59972 28.2455L0.61084 36.2393M7.59972 28.2455L0.610841 20.7846",
    stroke: "#773D0D",
    strokeWidth: 1.62264
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.2326,
    y1: 56.4902,
    x2: 23.2326,
    y2: 0.000667501,
    stroke: "#773D0D",
    strokeWidth: 1.62264
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.1882,
    y1: 56.4902,
    x2: 14.1882,
    y2: 0.000667501,
    stroke: "#773D0D",
    strokeWidth: 1.62264
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24.0439,
    y1: 35.9842,
    x2: 14.9995,
    y2: 35.9842,
    stroke: "#773D0D",
    strokeWidth: 1.62264
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24.0444,
    y1: 22.1287,
    x2: 15,
    y2: 22.1287,
    stroke: "#773D0D",
    strokeWidth: 1.62264
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardNfc);
export default __webpack_public_path__ + "static/media/card-nfc.e6d843590e2b3701105950be99cdf0ce.svg";
export { ForwardRef as ReactComponent };